export const createPipeTrunkPrintViewModelV2 = ({ companyLogo, formData = {} }) => ({
  title: "Pipe trunk entry FM111",
  companyLogo: companyLogo || "",
  vesselName: formData.shipName || "-",
  voyageNumber: formData.voyageNumber || "-",
  port: formData.port || "-",
  cargo: formData.cargo || "-",
  permit: formData.permit || {},
});
